var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Doc-grey"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Doc-grey",
    clipPath: "url(#clip-Doc-grey)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_749",
    "data-name": "Group 749",
    transform: "translate(8659.41 4250.571)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "google-docs",
    transform: "translate(-8656.41 -4248.571)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M70.026,2.912,67.217.1a.352.352,0,0,0-.248-.1H62.053A1.054,1.054,0,0,0,61,1.053v9.878a1.054,1.054,0,0,0,1.053,1.053h7.022a1.054,1.054,0,0,0,1.053-1.053V3.16A.354.354,0,0,0,70.026,2.912ZM67.32,1.2l1.61,1.61H67.671a.351.351,0,0,1-.351-.351Zm1.756,10.083H62.053a.352.352,0,0,1-.351-.351V1.053A.352.352,0,0,1,62.053.7h4.564V2.458a1.054,1.054,0,0,0,1.053,1.053h1.756v7.42A.352.352,0,0,1,69.075,11.282Z",
    transform: "translate(-61 0)",
    fill: "#686969"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M155.564,212h-4.213a.351.351,0,0,0,0,.7h4.213a.351.351,0,0,0,0-.7Z",
    transform: "translate(-148.893 -207.038)",
    fill: "#686969"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M155.564,272h-4.213a.351.351,0,0,0,0,.7h4.213a.351.351,0,0,0,0-.7Z",
    transform: "translate(-148.893 -265.633)",
    fill: "#686969"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M155.564,332h-4.213a.351.351,0,0,0,0,.7h4.213a.351.351,0,0,0,0-.7Z",
    transform: "translate(-148.893 -324.229)",
    fill: "#686969"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M154.16,392h-2.809a.351.351,0,1,0,0,.7h2.809a.351.351,0,1,0,0-.7Z",
    transform: "translate(-148.893 -382.825)",
    fill: "#686969"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocGrey);
export default __webpack_public_path__ + "static/media/doc-grey.e71f0d3b1f9b10f75e07a9fc0c9207b0.svg";
export { ForwardRef as ReactComponent };